import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AUTH_ROUTES, canActivateAdmin, canActivateUser } from '@shs-digi-care-monorepo/frontend-lib/auth';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const APP_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./menu/menu.component').then((m) => m.MenuComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request',
        loadComponent: () => import('./request/request.component').then((m) => m.RequestComponent),

        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request/:id',
        redirectTo: (route) => inject(Router).createUrlTree(['/requests'], { queryParams: { tab: route.params['id'] } })
    },
    {
        path: 'requests',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'tasks',
        redirectTo: (route) => inject(Router).createUrlTree(['/requests'], { queryParams: route.queryParams })
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'auth',
        children: AUTH_ROUTES
    },
    {
        path: '**',
        redirectTo: ''
    }
];
